import Logo from "@/components/Logo";
import { motion } from "framer-motion";
export default function Hero() {
  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      data-testid="hero-section"
      className="min-h-[75vh] flex items-center bg-white pt-20 relative overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1762013315117-1c8005ad2b41?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwyfHxmb290YmFsbCUyMHN0YWRpdW0lMjBjcm93ZCUyMGF0bW9zcGhlcmUlMjBuaWdodHxlbnwwfHx8fDE3NzY0MzUyNjF8MA&ixlib=rb-4.1.0&q=85"
          alt="Packed football stadium at night"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-white/90" />
      </div>

      <div className="max-w-6xl mx-auto px-6 w-full relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          className="max-w-3xl"
        >
          <div className="flex items-center gap-2 sm:gap-3 mb-3">
            <div className="hidden sm:block mt-2"><Logo size={90} /></div>
            <div className="sm:hidden mt-1"><Logo size={50} /></div>
            <h1 className="font-heading font-black text-4xl sm:text-6xl lg:text-8xl uppercase tracking-tighter leading-[0.9] text-[#1D3557]">
              target<span className="text-[#E63946]">funder</span><span className="text-[#1D3557]/30 hidden sm:inline">.com</span>
            </h1>
          </div>
          <p className="font-body text-sm uppercase tracking-[0.2em] text-[#1D3557]/40 mb-6">
            Supporting clubs everywhere
          </p>

          {/* Live banner */}
          <a href="https://app.targetfunder.com/worldcup2026/wiltonunitedfc" target="_blank" rel="noopener noreferrer" className="bg-[#1D3557] px-4 py-3 mb-6 inline-block hover:bg-[#152a47] transition-colors">
            <p className="font-body text-sm text-white">
              <span className="inline-block w-2 h-2 bg-[#E63946] rounded-full mr-2 animate-pulse"></span>
              The World Cup 2026 Predictor is <strong>live now</strong> — clubs and their members are competing on live leaderboards right now! <span className="underline ml-1">See Wilton United FC &rarr;</span>
            </p>
          </a>

          <p className="font-body text-lg sm:text-xl text-[#1D3557]/70 leading-relaxed max-w-2xl mb-6">
            We build <strong className="text-[#1D3557]">fun, professional fundraisers</strong> around the world's biggest sporting events — short bursts, big returns, zero hassle for your club.
          </p>

          <div className="border-l-2 border-[#E63946] pl-5 mb-4">
            <p className="font-body text-base text-[#1D3557]/60 leading-relaxed">
              Clubs are averaging <strong className="text-[#1D3557]">over €1,000 net in just 7 days</strong> — with zero hassle.
            </p>
          </div>

          {/* Coming soon - Open Golf */}
          <a href="https://app.targetfunder.com/demo/create?sport=golf" target="_blank" rel="noopener noreferrer" className="bg-[#F8FAFA] border border-[#1D3557]/10 p-4 mb-8 flex items-center gap-4 max-w-lg hover:border-[#1D3557]/25 transition-colors">
            <img
              src="https://customer-assets.emergentagent.com/job_sweepstake-builder/artifacts/mi8bq66z_download.png"
              alt="The Open Championship"
              className="w-16 h-16 object-contain flex-shrink-0"
            />
            <div>
              <p className="font-heading font-bold text-base uppercase tracking-tight text-[#1D3557]">
                New
              </p>
              <p className="font-heading font-bold text-xl uppercase tracking-tight text-[#E63946]">
                The Open Golf 2026 Predictor
              </p>
              <p className="font-body text-xs text-[#E63946] font-semibold mt-1">
                Try the free demo &rarr;
              </p>
            </div>
          </a>

          <div className="flex flex-col sm:flex-row gap-3">
            <button
              onClick={() => scrollTo("#contact")}
              className="border border-[#1D3557]/15 text-[#1D3557]/60 font-bold uppercase tracking-widest px-8 py-4 text-sm hover:border-[#1D3557] hover:text-[#1D3557] transition-colors"
              data-testid="hero-cta-secondary"
            >
              Have Questions? Get In Touch
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
